/*
 * @FilePath: /tongliao-nethall-h5-standard/src/router/index.js
 */
import Vue from 'vue';
import VueRouter from 'vue-router';
import serverconfig from '@/api/server.config';
const ROUTER_BASE = serverconfig.ROUTER_BASE;
import businessRouter from './business';
import { signRedirect } from '@/api/contract';

const Home = () => import('@/views/Home');
const Login = () => import('@/views//Home/Login');

// 用水条款说明
const WaterUsageTerms = () => import('@/views/Home/module/waterUsageTerms');
// 立即绑定
const Bind = () => import('@/views/Bind');
const HouseholderInfo = () => import('@/views/Bind/householderInfo');
const SelectBindAccount = () => import('@/views/Bind/selectBindAccount');
const NewBind = () => import('@/views/Bind/newBind');
const SearchClientNo = () => import('@/views/Bind/searchClientNo');

const QueryPay = () => import('@/views/QueryPay');
const FeeDetails = () => import('@/views/QueryPay/FeeDetails');
const PaymentSuccess = () => import('@/views/QueryPay/PaymentSuccess');
const PaymentPage = () => import('@/views/QueryPay/PaymentPage');
const PaymentResult = () => import('@/views/QueryPay/PaymentResult');

const WaterAccount = () => import('@/views/WaterAccount');
const PreStorage = () => import('@/views/WaterAccount/PreStorage');
const BindCustomer = () => import('@/views/WaterAccount/bindCustomer');
const RechargeRecord = () => import('@/views/WaterAccount/RechargeRecord');

// 电子发票
const Invoice = () => import('@/views/Invoice');
const InvoiceSetting = () => import('@/views/Invoice/invoiceSetting');
const InvoiceBill = () => import('@/views/Invoice/invoiceBill');
const InvoiceView = () => import('@/views/Invoice/invoiceView');
// 我的办理
const BusinessManagement = () => import('@/views/BusinessManagement');
// 用户信息
const WaterStatistics = () => import('@/views/WaterStatistics');
const SelectWaterUser = () => import('@/views/SelectWaterUser');
//反馈
const ViolationReport = () => import('@/views/Business/Feedback/ViolationReport');
const Proposal = () => import('@/views/Business/Feedback/Proposal');
const RepairApply = () => import('@/views/Business/Feedback/RepairApply');
const MyFeedBack = () => import('@/views/Feedback/MyFeedBack');

// 用户登录
const UserLogin = () => import('@/views/UserLogin');
const Setting = () => import('@/views/Setting');
const ChangeCurrentPhone = () => import('@/views/Setting/changeCurrenrPhone');
const ChangeNewPhone = () => import('@/views/Setting/changeNewPhone');
// 认证
const CertifiedPage = () => import('@/views/CertifiedPage');
const CardCertified = () => import('@/views/CertifiedPage/CardCertified');
const CardCertifiedList = () => import('@/views/CertifiedPage/CardCertifiedList');
const CertifiedContract = () => import('@/views/CertifiedPage/CertifiedContract');

// 公众信息
const BusinessOffice = () => import('@/views/PublicNews/BusinessOffice');

const charge = () => import('@/views/QueryPay/module/charge');

// 用水公告
const NewsNoticeClassify = () => import('@/views/NewsNotice/NewsNoticeClassify')
const NewsNotice = () => import('@/views/NewsNotice/NewsList')
const NewsDetail = () => import('@/views/NewsNotice/NewsDetail')
const UserCenterPage = () => import('@/views/UserCenterPage')

const BusinessConsult = () => import("@/views/BusinessConsult");
const NoticeList = () => import('@/views/NoticePage/NewsList')
const NoticeDetail = () => import('@/views/NoticePage/NewsList/NewsDetail')

// const pdf = () => import('@/views/Invoice/module/pdf');

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      title: '网上营业厅',
    },
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      title: '网上营业厅',
    },
  },
  {
    path: '/waterUsageTerms',
    name: 'WaterUsageTerms',
    component: WaterUsageTerms,
    meta: {
      title: '用水条款说明',
    },
  },
  /* 立即绑定 */
  {
    path: '/Bind',
    name: 'Bind',
    component: Bind,
    meta: {
      title: '用户绑定',
    },
  },
  {
    path: '/Bind/newBind',
    name: 'NewBind',
    component: NewBind,
    meta: {
      title: '用户绑定',
    },
  },
  {
    path: '/Bind/searchClientNo',
    name: 'SearchClientNo',
    component: SearchClientNo,
    meta: {
      title: '户号查询',
    },
  },
  {
    path: '/Bind/householderInfo',
    name: 'HouseholderInfo',
    component: HouseholderInfo,
    meta: {
      title: '用户绑定',
    },
  },
  {
    path: '/Bind/selectBindAccount',
    name: 'SelectBindAccount',
    component: SelectBindAccount,
    meta: {
      title: '选择绑定账号',
    },
  },
  /* 快捷缴费 */
  {
    path: '/QueryPay',
    name: 'QueryPay',
    component: QueryPay,
    meta: {
      title: '快捷缴费',
    },
  },
  /* 费用明细 */
  {
    path: '/QueryPay/FeeDetails',
    name: 'FeeDetails',
    component: FeeDetails,
    meta: {
      title: '未缴账单详情',
    },
  },
  {
    path: '/QueryPay/PaymentSuccess',
    name: 'PaymentSuccess',
    component: PaymentSuccess,
    meta: {
      title: '支付结果',
    },
  },
  {
    path: '/QueryPay/PaymentPage',
    name: 'PaymentPage',
    component: PaymentPage,
    meta: {
      title: '缴费',
    },
  },
  {
    path: '/QueryPay/PaymentResult',
    name: 'PaymentResult',
    component: PaymentResult,
    meta: {
      title: '支付结果',
    },
  },
  {
    path: '/WaterAccount',
    name: 'WaterAccount',
    component: WaterAccount,
    meta: {
      title: '用水账户',
    },
  },
  {
    path: '/WaterAccount/PreStorage',
    name: 'PreStorage',
    component: PreStorage,
    meta: {
      title: '充值缴费',
    },
  },
  {
    path: '/WaterAccount/RechargeRecord',
    name: 'RechargeRecord',
    component: RechargeRecord,
    meta: {
      title: '缴费记录',
    },
  },
  {
    path: "/BusinessConsult",
    name: "BusinessConsult",
    component: BusinessConsult,
    meta: {
      title: "业务咨询"
    }
  },
  {
    path: '/WaterAccount/bindCustomer',
    name: 'BindCustomer',
    component: BindCustomer,
    meta: {
      title: '绑定客户',
    },
  },

  /* 发票 */
  {
    path: '/Invoice',
    name: 'Invoice',
    component: Invoice,
    meta: {
      title: '电子发票',
    },
  },
  {
    path: '/Invoice/Bill',
    name: 'InvoiceBill',
    component: InvoiceBill,
    meta: {
      title: '电子发票信息',
    },
  },
  {
    path: '/Invoice/invoiceSetting',
    name: 'InvoiceSetting',
    component: InvoiceSetting,
    meta: {
      title: '开票设置',
    },
  },
  {
    path: '/WaterStatistics',
    name: 'WaterStatistics',
    component: WaterStatistics,
    meta: {
      title: '用户信息',
    },
  },
  /* 我的办理 */
  {
    path: '/BusinessManagement',
    name: 'BusinessManagement',
    component: BusinessManagement,
    meta: {
      title: '我的办理',
    },
  },
  {
    path: '/SelectWaterUser',
    name: 'SelectWaterUser',
    component: SelectWaterUser,
    meta: {
      title: '选择用户',
    },
  },
  //业务办理
  ...businessRouter,
  //反馈模块
  {
    path: '/Feedback/ViolationReport',
    name: 'ViolationReport',
    component: ViolationReport,
    meta: {
      title: '违章举报',
    },
  },
  {
    path: '/Feedback/Proposal',
    name: 'Proposal',
    component: Proposal,
    meta: {
      title: '意见反馈',
    },
  },
  {
    path: '/Feedback/RepairApply',
    name: 'RepairApply',
    component: RepairApply,
    meta: {
      title: '报事报修',
    },
  },
  {
    path: '/Feedback/MyFeedBack',
    name: 'MyFeedBack',
    component: MyFeedBack,
    meta: {
      title: '我的反馈',
    },
  },
  {
    path: '/UserLogin',
    name: 'UserLogin',
    component: UserLogin,
    meta: {
      title: '用户登录',
    },
  },
  {
    path: '/Setting',
    name: 'Setting',
    component: Setting,
    meta: {
      title: '设置',
    },
  },
  {
    path: '/Setting/changeCurrentPhone',
    name: 'ChangeCurrentPhone',
    component: ChangeCurrentPhone,
    meta: {
      title: '更换当前手机号',
    },
  },
  {
    path: '/Setting/ChangeNewPhone',
    name: 'ChangeNewPhone',
    component: ChangeNewPhone,
    meta: {
      title: '更换当前手机号',
    },
  },
  {
    path: '/CertifiedContract',
    name: 'CertifiedContract',
    component: CertifiedContract,
    meta: {
      title: '用户认证',
    },
  },
  {
    path: '/CertifiedPage',
    name: 'CertifiedPage',
    component: CertifiedPage,
    meta: {
      title: '用户认证',
    },
  },
  {
    path: '/CertifiedPage/CardCertified',
    name: 'CardCertified',
    component: CardCertified,
    meta: {
      title: '用户认证',
    },
  },
  {
    path: '/CertifiedPage/CardCertifiedList',
    name: 'CardCertifiedList',
    component: CardCertifiedList,
    meta: {
      title: '认证',
    },
  },
  {
    path: '/PublicNews/BusinessOffice',
    name: 'BusinessOffice',
    component: BusinessOffice,
    meta: {
      title: '营业网点',
    },
  },
  {
    path: '/charge',
    name: 'charge',
    component: charge,
    meta: {
      title: '缴费',
    },
  },
  // {
  //   path: '/weChat/pdf',
  //   name: 'pdf',
  //   component: pdf,
  //   meta: {
  //     title: '文件预览',
  //   },
  // },
  
  {
    path: '/NewsNotice/NewsNoticeClassify',
    name: 'NewsNoticeClassify',
    component: NewsNoticeClassify,
    meta: {
      title: '信息公告',
    },
  },
  {
    path: '/NewsNotice/NewsList',
    name: 'NewsNotice',
    component: NewsNotice,
    meta: {
      title: '公告',
    },
  },
  {
    path: '/NewsNotice/NewsDetail',
    name: 'NewsDetail',
    component: NewsDetail,
    meta: {
      title: '公告详情',
    },
  },
  {
    path: '/UserCenterPage/index',
    name: 'UserCenterPage',
    component: UserCenterPage,
    meta: {
      title: '我的',
    },
  },
  
  {
    path: '/NoticePage/NewsList',
    name: 'NoticePage',
    component: NoticeList,
    meta: {
      title: '新闻',
    },
  },
  {
    path: '/NoticePage/NewsList/NewsDetail',
    name: 'NoticeDetail',
    component: NoticeDetail,
    meta: {
      title: '',
    },
  },
  {
    path: '/NoticePage/NewsList/NewsDetail',
    name: 'NoticeDetail',
    component: NoticeDetail,
    meta: {
      title: '',
    },
  },
  {
    path: '/Invoice/InvoiceView',
    name: 'InvoiceView',
    component: InvoiceView,
    meta: {
      title: '',
    },
  },
];

const router = new VueRouter({
  mode: 'hash',
  routes,
});

router.beforeEach(async (to, from, next) => {
  if (to.path === '/block') {
    const title = to.meta && to.meta.title;
    if (title) {
      document.title = title;
    }
    let res = await signRedirect(to.query.businessFlowId);
    next({ path: '/blockOperate', query: { ...res, businessFlowId: to.query.businessFlowId } });
  } else {
    const title = to.meta && to.meta.title;
    if (title) {
      document.title = title;
    }
    next();
  }
});

export default router;
